import { render, staticRenderFns } from "./Fase9.vue?vue&type=template&id=18dfa6e7&scoped=true"
import script from "./Fase9.vue?vue&type=script&lang=js"
export * from "./Fase9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfa6e7",
  null
  
)

export default component.exports